import sImg1 from '../images/featured/featuredThumb1.jpg'
import sImg2 from '../images/featured/featuredThumb2.jpg'
import sImg3 from '../images/featured/featuredThumb3.jpg'
import sImg4 from '../images/featured/featuredThumb4.jpg'
import sImg5 from '../images/featured/featuredThumb5.jpg'
import sImg6 from '../images/featured/featuredThumb6.jpg'

import suImg1 from '../images/update/featuredThumb4.jpg'
import suImg2 from '../images/update/featuredThumb5.jpg'
import suImg3 from '../images/update/featuredThumb6.jpg'
import suImg4 from '../images/update/featuredThumb4.jpg'


import img1 from '../assets/img_1.jpg'
import img2 from '../assets/img_2.webp'
import img3 from '../assets/health-benefits.png'
import img4 from '../assets/img4.jpeg'
import img5 from '../assets/img5.jpeg'
import img6 from '../assets/img6.webp'
import img7 from '../assets/img7.jpg'

import event1 from '../assets/event1.png'
import event2 from '../assets/event2.jpg'
import event3 from '../assets/event5.jpg'



const Donation = [
    {
        Id: '1',
        sImg:event1,
        suImg:event1,
        title: 'Blood Donation - 1',
        slug: 'Blood donation 1',
        thumb:'#BGB',
        venue: "Bill Gates Bhavan",
        date: "10-02-2024",
        progress:'80%',
        goal:'$28.0000',
        raised:'$9,9098',
        togo:'$34,000',
        description:'',
        category: 'education',
    },
    {
        Id: '2',
        sImg:event2,
        suImg:event2,
        title: 'Blood Donation - 2',
        slug: 'Blood Donation 2',
        venue: "Ratan tata Bhavan",
        thumb:'#RTB',
        date: "11-02-2024",
        progress:'70%',
        goal:'$58.0000',
        raised:'$10,908',
        togo:'$84,000',
        description:'We have covered many special events such as fireworks, fairs, parades, races, walks,',
        category: 'medical',
    },
    {
        Id: '3',
        sImg:event3,
        suImg:event3,
        title: 'Blood Donation - 3',
        slug: 'Blood Donation - 3',
        date: "12-02-2024",
        venue: "Visweshvaraya Bhavan",
        thumb:'#VB',
        progress:'60%',
        goal:'$88.0000',
        raised:'$6,908',
        togo:'$74,000',
        description:'We have covered many special events such as fireworks, fairs, parades, races, walks,',
        category: 'Home',
    },
    {
        Id: '4',
        sImg:img4,
        suImg:suImg4,
        title: 'Blood Donation - 4',
        venue: "Cotton Bhavan",
        slug: 'Little-Help-Can-Make-a-Big-Difference',
        date: "13-02-2024",
        thumb:'#CB',
        progress:'80%',
        goal:'$98.0000',
        raised:'$9,508',
        togo:'$44,000',
        description:'We have covered many special events such as fireworks, fairs, parades, races, walks,',
        category: 'medical',
    },
    {
        Id: '5',
        sImg:img3,
        title: 'Blood Donation - 5',
        date: "14-02-2024",
        slug: 'Blood Donation -5',
        venue: "Ramanujan Bhavan",
        thumb:'#RB',
        progress:'65%',
        goal:'$38.0000',
        raised:'$3,908',
        togo:'$75,000',
        description:'We have covered many special events such as fireworks, fairs, parades, races, walks,',
        category: 'Food',
    },
    {
        Id: '6',
        sImg:img2,
        venue: "Edison Bhavan",
        title: 'Blood Donation-6',
        slug: 'Blood Donation - 6',
        date: "15-02-2024",
        thumb:'#EB',
        progress:'55%',
        goal:'$78.0000',
        raised:'$8,908',
        togo:'$52,000',
        description:'We have covered many special events such as fireworks, fairs, parades, races, walks,',
        category: 'education',
    },
]    

export default Donation;